import React from "react";

export function LayoutsLogin(props) {
  const { children } = props;
  return <div>{children}</div>;
}
